// extracted by mini-css-extract-plugin
export default {"Header_Cnt":"COM001F1_Header_Cnt__RnTEU","portalLogo":"COM001F1_portalLogo__IBBdH","infoBox":"COM001F1_infoBox__8YAb3"};